// extracted by mini-css-extract-plugin
export default {"container":"con_10n_","inner":"con_inn_3p6h0","wait":"con_wai_3pfmW"};